import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { SessionProvider } from "./store/sessionContext";
import "typeface-roboto";
import "typeface-montserrat";
import { OfficeProvider } from "./store/officeContext";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme";
import { PersonProvider } from "./store/personContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SessionProvider>
        <PersonProvider>
          <OfficeProvider>
            <App />
          </OfficeProvider>
        </PersonProvider>
      </SessionProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
reportWebVitals();
